import React     from 'react'
import { Panel } from 'react-bootstrap'

export default AltoPanel = ({ bsStyle = 'info', id, className, header, children }) ->
  <Panel bsStyle={bsStyle} id={id} className={className}>
    <Panel.Heading>
      <Panel.Title>{header}</Panel.Title>
    </Panel.Heading>

    {<Panel.Body>{children}</Panel.Body> if children}
  </Panel>
